import {Routes} from '@src/Constant/routes';
import {RouteComponentProps} from '@reach/router';
import React from 'react';
import {KeyRouteMap} from '../types';

// Composants liés au visionnage
const AppHomeWatch = React.lazy(
  () => import('@src/App/components/pages/homeWatch/AppHomeWatch'),
);
const AppWatchLiveTV = React.lazy(
  () => import('@src/App/components/pages/homeWatch/LiveTvScreen/LiveTvScreen'),
);
const AppWatchLiveEvents = React.lazy(
  () =>
    import(
      '@src/App/components/pages/homeWatch/LiveEventScreen/LiveEventScreen'
    ),
);
const AppCategorieWatch = React.lazy(
  () => import('@src/App/components/pages/categorieWatch/AppCategorieWatch'),
);
const NewsWatchPage = React.lazy(
  () =>
    import('@src/App/components/pages/homeWatch/NewsWatchPage/NewsWatchPage'),
);
const AppVideoPlayerVerticale = React.lazy(
  () =>
    import('@src/App/components/pages/AppVideoPlayer/AppVideoPlayerVerticale'),
);
const VodHomePage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/homeWatch/VodPage/VodHomePage/VodHomePage'
    ),
);
const VodSinglePage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/homeWatch/VodPage/VodSinglePage/VodSinglePage'
    ),
);
const VodCollectionPage = React.lazy(
  () =>
    import(
      '@src/App/components/pages/homeWatch/VodPage/VodCollectionPage/VodCollectionPage'
    ),
);

const emptyRoute = {
  component: React.lazy(() => {
    const EmptyComponent = () => React.createElement('div');
    return Promise.resolve({default: EmptyComponent});
  }),
};

export const watchRoutes: KeyRouteMap = {
  [Routes.HOME_WATCH]: {component: AppHomeWatch},
  [Routes.LIVE_TV]: {component: AppWatchLiveTV},
  [Routes.LIVE_EVENTS_ITEM]: emptyRoute,
  [Routes.LIVE_EVENTS]: {
    component: AppWatchLiveEvents,
    parent: Routes.HOME_WATCH,
  },
  [Routes.NEWS_HOME]: {
    component: NewsWatchPage,
    parent: Routes.HOME_WATCH,
  },
  [Routes.NEWS_SINGLE]: {
    component: AppVideoPlayerVerticale,
    parent: Routes.HOME_WATCH,
  },
  [Routes.VOD_HOME]: {
    component: VodHomePage,
    parent: Routes.HOME_WATCH,
  },
  [Routes.VOD_SINGLE]: {
    component: VodSinglePage,
    parent: Routes.HOME_WATCH,
  },
  [Routes.VOD_COLLECTION]: {
    component: VodCollectionPage,
    parent: Routes.HOME_WATCH,
  },
  [Routes.VOD_CATEGORY]: {
    component: AppCategorieWatch,
    parent: Routes.HOME_WATCH,
  },
  [Routes.VOD_CATEGORY_HOME]: {
    component: AppCategorieWatch,
    parent: Routes.HOME_WATCH,
  },
};
